import classNames from 'classnames';
import styles from './BetaLabel.module.scss';

interface BetaLabelProps {
  isAbsolute?: boolean;
  className?: string;
}

export const BetaLabel = ({ isAbsolute, className }: BetaLabelProps) => {
  return (
    <span
      className={classNames(
        styles.root,
        { [styles.absolute]: isAbsolute },
        className,
      )}
    >
      Beta
    </span>
  );
};
